import { Link } from "react-router-dom";

const LOGO = `${process.env.PUBLIC_URL || ""}/A-Learning-Lab-Logo.png`;

export function BrandLogo({ className = "w-auto", showTagline = true, tall = false }) {
  const imgSize = tall ? "h-16 w-auto sm:h-[4.5rem]" : "h-12 w-auto sm:h-14";

  return (
    <Link
      to="/"
      className="inline-flex items-center gap-3 group"
      data-testid={tall ? "footer-brand" : undefined}
    >
      <img
        src={LOGO}
        alt="A Learning Lab"
        width={tall ? 120 : 56}
        height={tall ? 120 : 56}
        className={`${className} ${imgSize} object-contain object-left group-hover:opacity-90 transition-opacity`}
        draggable={false}
      />
      {showTagline ? (
        <>
          <div className="ml-1 hidden h-8 w-px bg-brand-200 sm:block" />
          <span className="hidden text-[10px] font-bold uppercase tracking-widest text-ink/60 sm:block">
            by UniHawk
          </span>
        </>
      ) : null}
    </Link>
  );
}
